// Use relative path so API calls use the same host as the page
export const BASE_URL = "/api";
// Alternative options:
// Docker: API through NGINX
// export const BASE_URL = "http://localhost/api";
// Production: API through NGINX
// export const BASE_URL = "https://vlm.voicera-analytics.in/api";
// Local development: Direct backend
// export const BASE_URL = "http://localhost:8081";

export const HEADERS = () => {
    const token = JSON.parse(sessionStorage.getItem('candidateCreds'));
    // console.log('USER : ', user);

    if (token) {
        // console.log('returning', { Authorization: user.token });
        return {
            headers: {
                Authorization:token
            }
        };
    } else {
        return {};
    }
};